import { SPage } from "src/components/spage";

interface IProps {}
export const CancellationsPage = ({}: IProps) => {
  return <SPage title={"Cancellations"}></SPage>;
};
